<template>
  <a :href="href" class="social-btn mgr-btn" :style="loginButtonStyles" @click="logMessengerClick">
    <i v-show="baseData.branding.iconVisible" class="fa fa-comment-o" />
    <span v-text="$t('messenger')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    name: 'MessengerButton',
    props: ['api', 'action', 'wftkn'],
    data() {
      return {
        href: '',
      }
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#0084ff',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.loginOptions.styles.layout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.branding.loginButtonTextAlign.value
      },
      loginButtonColor() {
        return this.baseData.loginOptions.styles.buttons.messengerButtonColor
      },
      loginButtonTextColor() {
        return this.baseData.loginOptions.styles.buttons.loginButtonsTextColor
      },
    },
    mounted() {
      if (this.api.includes('preview')) {
        this.href = '#'
      } else {
        this.href = `${this.api}&action=${this.action}&wftkn=${this.wftkn}`
      }
    },
    methods: {
      logMessengerClick() {
        logUserAction({
          type: 'user_action',
          label: 'User Clicked Messenger Login Button'
        });
      },
    },
  }
</script>

<style>
  .mgr-btn {
    background: #0084ff;
  }
  .mgr-btn:hover {
    background: #0066cc;
  }
</style>
